routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

// config file
import GlobalConfig from '../../../../../../globals/globalConfig.json'

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)
  $stateProvider
  .state('workplan.reviewAcademicManagement', {
    abstract: false,
    url: '/reviewAcademicManagement/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.academicManagement,
    data: {
      displayName: 'Gestión Académica',
      title: 'Gestión Académica',
      order: 4,
      siblings: [
        {
          name: 'fullscreen.workPlanReview',
          order: 0
        },
        {
          name: 'workplan.reviewTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryReview',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: 'review',
      roleId: GlobalConfig.userRolesIds.reviewer,
      inHistory: false
    }
  })
  .state('workplan.approvalAcademicManagement', {
    abstract: false,
    url: '/approvalAcademicManagement/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.academicManagement,
    data: {
      displayName: 'Gestión Académica',
      title: 'Gestión Académica',
      order: 4,
      siblings: [
        {
          name: 'fullscreen.workPlanApproval',
          order: 0
        },
        {
          name: 'workplan.approvalTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.approvalExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryApproval',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: 'approval',
      roleId: GlobalConfig.userRolesIds.approver,
      inHistory: false
    }
  })
  .state('workplan.executionAcademicManagement', {
    abstract: false,
    url: '/executionAcademicManagement',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.academicManagement,
    data: {
      displayName: 'Gestión Académica',
      title: 'Gestión Académica',
      order: 4,
      siblings: [
        {
          name: 'fullscreen.workPlanExecution',
          order: 0
        },
        {
          name: 'workplan.executionTeaching',
          order: 1
        },
        {
          name: 'workplan.executionConsolidation',
          order: 5
        },
        {
          name: 'workplan.executionInvestigation',
          order: 2
        },
        {
          name: 'workplan.executionExtension',
          order: 3
        },
        {
          name: 'workplan.executionHistory',
          order: 6
        }
      ]
    },
    params: {
      stage: 'execution',
      roleId: GlobalConfig.userRolesIds.teacher,
      inHistory: false
    }
  })
  .state('workplan.reviewExecutionAcademicManagement', {
    abstract: false,
    url: '/reviewExecutionAcademicManagement/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.academicManagement,
    data: {
      displayName: 'Gestión Académica',
      title: 'Gestión Académica',
      order: 4,
      siblings: [
        {
          name: 'fullscreen.workPlanReviewExecution',
          order: 0,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.reviewExecutionExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryReviewExecution',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: 'reviewExecution',
      roleId: GlobalConfig.userRolesIds.reviewer,
      inHistory: false
    }
  })
  .state('workplan.evaluationAcademicManagement', {
    abstract: false,
    url: '/evaluationAcademicManagement/teacher/:teacherId?name/workplan/:workplanId',
    template: '<activities-review></activities-review>',
    module: GlobalConfig.modules.academicManagement,
    data: {
      displayName: 'Gestión Académica',
      title: 'Gestión Académica',
      order: 4,
      siblings: [
        {
          name: 'fullscreen.workPlanEvaluation',
          order: 0
        },
        {
          name: 'workplan.evaluationTeaching',
          order: 1,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationConsolidation',
          order: 5,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationInvestigation',
          order: 2,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.evaluationExtension',
          order: 3,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        },
        {
          name: 'workplan.summaryEvaluation',
          order: 6,
          params: {
            teacherId: 'teacherId',
            workplanId: 'workplanId',
            name: 'name'
          }
        }
      ]
    },
    params: {
      stage: 'evaluation',
      roleId: GlobalConfig.userRolesIds.approver,
      inHistory: false
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/routes/academicManagement.route.js